import { useQuery } from '@tanstack/react-query';
import { Product } from '$/models/Product';
import productRepository from '@/api/repositories/productRepository/ProductRepository.ts';
import { Filters } from '$/repositories/supabaseRepository/SupabaseRepository.ts';
import { filtersToStringArray } from '@/utils/filtersToStringArray.ts';

const useProducts = (enabled: boolean = true, filters: Filters<Product> | undefined = undefined) => {
  const queryKey = ['products', ...filtersToStringArray(filters)];

  const queryFn = async () => {
    return getProducts(filters);
  };

  return useQuery({
    queryKey,
    queryFn,
    enabled,
    staleTime: 1000 * 60 * 5,
  });
};

export default useProducts;

async function getProducts(filters?: Filters<Product>): Promise<Product[]> {
  const { data, error } = filters
    ? await productRepository.findMany(filters, {
        order: {
          by: 'price',
          ascending: true,
        },
      })
    : await productRepository.all({
        order: {
          by: 'price',
          ascending: true,
        },
      });

  if (error) throw new Error(error.message);

  return data ?? [];
}
